/* eslint-disable */
import React from 'react';
import { Redirect } from 'react-router-dom';
import Sections from '~/sections';
import { Tabs } from '~/sections/MainPage/Info/Tabs';
import FormSchedule from '~/components/FormSchedule/FormSchedule';
import { Comparativo } from '~/sections/V360Page/Info/Comparativo';
import router from './router';

export const routes = [
	{
		exact: true,
		path: '/',
		component: (props) => <Sections {...props} />,
	},
	{
		exact: true,
		path: '/1',
		component: (props) => null,
	},
	{
		exact: true,
		path: '/2',
		component: (props) => null,
	},
	{
		modal: true,
		defaultParentPath: '/',
		path: '/robustez',
		component: (props) => <Tabs {...props} />,
	},
	{
		modal: true,
		defaultParentPath: '/',
		path: '/seguridad',
		component: (props) => <Tabs {...props} />,
	},
	{
		modal: true,
		defaultParentPath: '/',
		path: '/comparativo',
		component: (props) => <Comparativo {...props} />,
	},
	{
		modal: true,
		defaultParentPath: '/',
		path: '/capacidad-de-carga',
		component: (props) => <Tabs {...props} />,
	},
	{
		modal: true,
		defaultParentPath: '/',
		path: '/espacio-interno',
		component: (props) => <Tabs {...props} />,
	},
	{
		modal: true,
		defaultParentPath: '/',
		path: '/tecnologia',
		component: (props) => <Tabs {...props} />,
	},
	{
		modal: true,
		defaultParentPath: '/',
		path: '/diseno',
		component: (props) => <Tabs {...props} />,
	},
	{
		path: '/agende',
		render: (props) => <FormSchedule {...props} />,
	},
	{
		path: '*',
		render: () => <Redirect to='/' />,
	},
];

export default router(routes);
